import React, { Component } from 'react';
import NavBarInverted from '../../components/nav/NavBarInverted.component.jsx';
import FooterLarge from '../../components/footer/FooterLarge.jsx';
import Search from '../../components/blog/Search';
import ScientificResearch from '../../components/blog/ScientificResearch';
import Educational from '../../components/blog/Educational';
import Articles from '../../components/blog/Articles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Centers from '../../components/blog/Centers';
import Videos from '../../components/blog/Videos';
import { api_url, headers } from '../../common/config';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import Loader from 'react-loader-spinner';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
import FooterHover from '../../components/footer/FooterHover';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role='tabpanel'
            hidden={value !== index}
            id={`scrollable-prevent-tabpanel-${index}`}
            aria-labelledby={`scrollable-prevent-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography component={'div'}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `scrollable-prevent-tab-${index}`,
        'aria-controls': `scrollable-prevent-tabpanel-${index}`,
    };
}

class Blog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: 0,
            videos: [],
            research: [],
            guides: [],
            centers: [],
            articles: [],
            city: '',
            filtered: false,
            filterCity: '',
            filterDistrict: '',
            filterMinistry: '',
            noResults: true,
            videosResults: true,
            researchResults: true,
            guidesResults: true,
            centersResults: true,
            articlesResults: true,
        };
    }
    handleChange = (e, v) => {
        this.getAllResources();
        this.setState({
            value: v,
        });
    };

    showAllBtnCent = () => {
        window.scrollTo(0, 0);
        this.setState({
            value: 1,
        });
    };

    changeCity = (e) => {
        this.setState({
            city: e.label,
        });
    };

    // showAllBtnEdu = () => {
    //     window.scrollTo(0, 0);
    //     this.setState({
    //         value: 2,
    //     });
    // };

    showAllBtnVid = () => {
        window.scrollTo(0, 0);
        this.setState({
            value: 2,
        });
    };

    showAllBtnSci = () => {
        window.scrollTo(0, 0);
        this.setState({
            value: 3,
        });
    };

    showAllBtnArt = () => {
        window.scrollTo(0, 0);
        this.setState({
            value: 4,
        });
    };

    componentDidMount() {
        this.getAllResources();
    }

    isFilterPram = (search) => {
        let filterPram = '';
        if (!search == '') {
            filterPram =
                '&filter[title][like]=' +
                search +
                '&filter[author_name][logical]=or&filter[author_name][like]=' +
                search;
            return filterPram;
        }
        return filterPram;
    };

    isVideoPram = (search) => {
        let filterPram = '';
        if (!search == '') {
            filterPram = '&filter[title][like]=' + search;
            return filterPram;
        }
        return filterPram;
    };

    isTagPram = (search) => {
        let tagPram = '';
        if (!search == '') {
            tagPram = '&filter[tag][like]=' + search;
            return tagPram;
        }
        return tagPram;
    };
    getAllResources = (search) => {
        this.getResourcesPageVideos(search);

        this.getResourcesPageResearch(search);

        this.getResourcesPageCenters(search);

        this.getArticles(search);
    };

    getResourcesPageVideos = (search, tag) => {
        fetch(
            `${api_url}/autism/items/resources_page_videos?filter[status]=published${this.isVideoPram(
                search
            )}${this.isTagPram(tag)}`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    videos: res.data,
                });
                if (res.data.length > 0) {
                    this.setState({
                        videosResults: true,
                    });
                } else {
                    this.setState({
                        videosResults: false,
                    });
                }
            });
    };

    getResourcesPageResearch = (search) => {
        fetch(
            `${api_url}/autism/items/resources_page_research?filter[status]=published${this.isFilterPram(
                search
            )}`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    research: res.data,
                });
                if (res.data.length > 0) {
                    this.setState({
                        researchResults: true,
                    });
                } else {
                    this.setState({
                        researchResults: false,
                    });
                }
            });
    };

    getResourcesPageGuides = (search) => {
        fetch(
            `${api_url}/autism/items/resources_page_guides${this.isFilterPram(
                search
            )}`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    guides: res.data,
                });
                if (res.data.length > 0) {
                    this.setState({
                        guidesResults: true,
                    });
                } else {
                    this.setState({
                        guidesResults: false,
                    });
                }
            });
    };

    getResourcesPageCenters = (search) => {
        let filterPram = '';
        if (!search == '') {
            filterPram = '?filter[name][like]=' + search;
        }
        fetch(`${api_url}/autism/items/resources_page_centers${filterPram}`, {
            method: 'GET',
            // headers: headers,
        })
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    centers: res.data,
                });
                if (res.data.length > 0) {
                    this.setState({
                        centersResults: true,
                    });
                } else {
                    this.setState({
                        centersResults: false,
                    });
                }
            });
    };

    filterCentersCity = (filter) => {
        this.setState(
            {
                filterCity: filter,
            },
            () => {
                this.filterCenters();
            }
        );
    };

    filterCentersDistrict = (filter) => {
        this.setState(
            {
                filterDistrict: filter,
            },
            () => {
                this.filterCenters();
            }
        );
    };

    filterCentersMinistry = (filter) => {
        this.setState(
            {
                filterMinistry: filter,
            },
            () => {
                this.filterCenters();
            }
        );
    };

    filterCenters = () => {
        fetch(
            `${api_url}/autism/items/resources_page_centers?filter[name][nnull]${
                this.state.filterCity !== ''
                    ? `&filter[city]=${this.state.filterCity}`
                    : ''
            }${
                this.state.filterDistrict !== ''
                    ? `&filter[state]=${this.state.filterDistrict}`
                    : ''
            }${
                this.state.filterMinistry !== ''
                    ? `&filter[ministry]=${this.state.filterMinistry}`
                    : ''
            }`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then(function (response) {
                console.log(response.status); // Will show you the status
                if (response.ok) {
                    // throw new Error('HTTP status ' + response.status);
                    return response.json();
                }
            })
            .then((res) => {
                this.setState({
                    centers: res.data,
                    filtered: true,
                });
            });
    };

    getArticles = (search) => {
        fetch(
            `${api_url}/autism/items/articles?filter[status]=published${this.isFilterPram(
                search
            )}`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    articles: res.data,
                });
                if (res.data.length > 0) {
                    this.setState({
                        articlesResults: true,
                    });
                } else {
                    this.setState({
                        articlesResults: false,
                    });
                }
            });
    };
    searchInput = (search) => {
        switch (this.state.value) {
            case 1:
                this.getResourcesPageCenters(search);
                break;
            case 2:
                this.getResourcesPageVideos(search);
                break;
            case 3:
                this.getResourcesPageResearch(search);
                break;
            case 4:
                this.getArticles(search);
                break;
            default:
                this.getAllResources(search);
        }
    };

    componentDidMount() {
        this.getAllResources();
        if (i18next.language === 'ar') {
            document.getElementsByTagName('html')[0].setAttribute('lang', 'ar');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
            document.getElementById('root').style.textAlign = 'right';
            document.getElementById('root').dir = 'rtl';
        } else if (i18next.language === 'en') {
            document.getElementsByTagName('html')[0].setAttribute('lang', 'en');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
            document.getElementById('root').style.textAlign = 'left';
            document.getElementById('root').dir = 'ltr';
        }
    }

    render() {
        const {
            value,
            centers,
            videos,
            research,
            guides,
            articles,
        } = this.state;

        const { t } = this.props;
        return (
            <div className='blog-container'>
                <NavBarInverted big blog />
                <div
                    className={`blog-page ${
                        i18next.language === 'en' ? '' : ''
                    }`}
                >
                    <Search
                        value={value}
                        handleChange={this.handleChange}
                        a11yProps={a11yProps}
                        searchInput={this.searchInput}
                        centers={centers}
                        changeCity={this.changeCity}
                        filterCentersCity={this.filterCentersCity}
                        filterCentersDistrict={this.filterCentersDistrict}
                        filterCentersMinistry={this.filterCentersMinistry}
                        city={this.state.filterCity}
                        district={this.state.filterDistrict}
                        ministry={this.state.filterMinistry}
                        clear={this.clearFilters}
                    />

                    <TabPanel value={value} index={0}>
                        {(centers.length ||
                            videos.length ||
                            research.length ||
                            articles.length) === 0 ? (
                            <div className='blog-loader'>
                                {this.state.centersResults === false &&
                                this.state.researchResults === false &&
                                this.state.videosResults === false &&
                                this.state.articlesResults === false ? (
                                    <p>{t('noResults')}</p>
                                ) : (
                                    <Loader
                                        type='Grid'
                                        color='#7670ff'
                                        height={100}
                                        width={100}
                                        timeout={15000} //5 secs
                                    />
                                )}
                            </div>
                        ) : (
                            <>
                                {centers.length === 0 ? (
                                    <></>
                                ) : (
                                    <Centers
                                        isGrid={false}
                                        showAllBtn={this.showAllBtnCent}
                                        centers={centers}
                                    />
                                )}
                                {videos.length === 0 ? (
                                    <></>
                                ) : (
                                    <Videos
                                        isGrid={false}
                                        showAllBtn={this.showAllBtnVid}
                                        videos={videos}
                                    />
                                )}
                                {research.length === 0 ? (
                                    <></>
                                ) : (
                                    <ScientificResearch
                                        isGrid={false}
                                        showAllBtn={this.showAllBtnSci}
                                        research={research}
                                    />
                                )}
                                {articles.length === 0 ? (
                                    <></>
                                ) : (
                                    <Articles
                                        showAll={false}
                                        showAllBtn={this.showAllBtnArt}
                                        articles={articles}
                                    />
                                )}
                            </>
                        )}
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <Centers
                            centers={centers}
                            isGrid={true}
                            filtered={this.state.filtered}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <Videos videos={videos} isGrid={true} />
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <ScientificResearch research={research} isGrid={true} />
                    </TabPanel>
                    <TabPanel value={value} index={4}>
                        <Articles articles={articles} showAll={true} />
                    </TabPanel>
                </div>
                <FooterHover />
                <FooterLarge minimal />
            </div>
        );
    }
}

export default withTranslation()(Blog);
